export default __webpack_public_path__ + "static/media/bmp.02adcbd1.png";